import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { Router, RouteConfigLoadStart, RouteConfigLoadEnd, Event } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { LoaderService } from './shared/loader/LoaderService';
import { LoaderComponent } from './shared/loader/loader.component';
import { ApiConfiguration } from './shared/api';
import { SessionMonitorService } from './core/services/session-monitor.service';

/**
 * Modern standalone root component
 * Uses inject() pattern and minimal imports
 */
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, LoaderComponent, MatProgressSpinnerModule],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  // Modern inject() pattern - no constructor injection needed
  private router = inject(Router);
  private loaderService = inject(LoaderService);
  private apiConfiguration = inject(ApiConfiguration);
  private translate = inject(TranslateService);
  private sessionMonitor = inject(SessionMonitorService);

  title = 'admin';
  private asyncLoadCount = 0;

  ngOnInit(): void {
    this.configureApiEnvironment();
    this.setupRouterLoading();
    this.sessionMonitor.start();
  }

  private configureApiEnvironment(): void {
    let env = localStorage.getItem('env');
    if (env === 'dev') {
      localStorage.setItem('env', 'dev');
      this.apiConfiguration.rootUrl = 'https://ia-dev-dashboard-api.transflo.com';
    } else if (env === 'stg') {
       // this.apiConfiguration.rootUrl = 'https://localhost:7091'
      // this.apiConfiguration.rootUrl = 'https://dkv52rnz4qtgn.cloudfront.net';
      this.apiConfiguration.rootUrl = 'https://ia-stg-dashboard-api.transflo.com';
    } else if (env === 'prod'  || !env) {
      this.apiConfiguration.rootUrl = 'https://dci6o9ti27oeh.cloudfront.net';
    }
  }

  private setupRouterLoading(): void {
    this.router.events.subscribe((event: Event): void => {
      if (event instanceof RouteConfigLoadStart) {
        this.asyncLoadCount++;
      } else if (event instanceof RouteConfigLoadEnd) {
        this.asyncLoadCount--;
      }

      if (this.asyncLoadCount > 0) {
        this.loaderService.show();
      } else {
        this.loaderService.hide();
      }

      // Hide loader after 2 seconds as fallback
      setTimeout(() => {
        this.loaderService.hide();
      }, 2000);
    });
  }
}
